var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoritesEmptyView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 67,
    viewBox: "0 0 83 67",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 61.7443C6.50378 59.2185 21.4876 59.7354 35.6803 62.6925C37.4806 63.0676 38.7735 61.1271 37.6058 59.7064C30.2829 50.7965 16 35.8893 16 35.8893C16 35.8893 0.5 21.8787 14.0217 7.30874C22.9312 -2.29137 33.4694 3.57008 36.9816 6.07217C37.985 6.78698 39.2904 8.95198 40.2135 10.6518C40.9462 12.001 40.7445 13.6447 39.7803 14.8395L37.8838 17.1893C36.8434 18.4783 36.5091 20.199 36.9909 21.7839L38.3713 26.3243C38.5936 27.0554 38.5285 27.8438 38.1894 28.5285L36.6716 31.5928C36.1905 32.5641 37.3824 33.4997 38.2117 32.8017L41.7256 29.8439C42.6438 29.071 43.013 27.8253 42.6642 26.6769L41.7816 23.771C41.1907 21.8255 41.8368 19.7159 43.4159 18.4349L46.2035 16.1737C47.3119 15.2745 47.6334 13.7189 46.9722 12.454L46.1876 10.9531C44.992 8.66579 45.0113 5.83126 47.2335 4.51856C52.2456 1.55784 61.9858 0.348992 69 7.30876C79.3374 17.5658 71.788 30.9555 67 35.8893L44.7133 59.3464C43.1742 60.9664 43.9012 63.5704 46.1101 63.9079C56.8265 65.5452 73.7328 64.5033 81.5 59.2615",
    stroke: "var(--fontCaptionColor)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesEmptyView);
export default __webpack_public_path__ + "static/media/favorites_empty_view.a7e7979a.svg";
export { ForwardRef as ReactComponent };